import React, { useContext, useEffect } from 'react';
import './Pagination.css';
import Pagination from 'react-bootstrap/Pagination'
import { SearchContext } from '../Provider/Provider';
import config from '../../config.json';

const SIZE = 20;

const SeedPagination = () => {
  const { total, active, setActive, search } = useContext(SearchContext);
  const pageSize = config.query.size ? config.query.size : SIZE;

  /**
   * Scroll to top on page change.
   */
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [active])

  /**
   * Requests next set of items from Elastic.
   * 
   * @param {Event} event The on click event.
   */
  const handleClick = (event) => {
    var itemClicked = event.target.text;
    if (itemClicked) {
      itemClicked = parseInt(itemClicked);
      let from = itemClicked === 1 ? 0 : (itemClicked - 1) * pageSize;
      setActive(itemClicked);
      search(from);
    }
  }

  const renderPageNumbers = () => {
    let current = active;
    let items = [];
    let pages = total/pageSize === 0 ? 0 : Math.ceil(total/pageSize);
    
    for (let number = 1; number <= pages; number++) {
      items.push(
        <Pagination.Item key={number} active={number === current} onClick={handleClick}>
          {number}
        </Pagination.Item>,
      );
    }

    return items;
  }

  return (
    <div className="Pagination">
      { total > 0 && total > pageSize &&
        <Pagination>{renderPageNumbers()}</Pagination>
      }
    </div>
  );
};

export default SeedPagination;